module.exports = "/_next/static/images/64a95389218e572c98b0da37dba84e7d-email-verification-loading.png.webp";